/* ============================================================
   MISTER DALLE — Enhancement JS
   ============================================================ */
(function () {
  'use strict';

  /* ── Sticky header on scroll ── */
  var header = document.getElementById('header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('md-scrolled', window.scrollY > 60);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Scroll reveal (IntersectionObserver) ── */
  var revealTargets = [
    '.card-wrapper',
    '.service-item',
    '.blog-card',
    '.article-card',
    '.card--article',
    '.faq-item',
    '.new-faq-item',
    '.footer-block',
    '.benefit-item',
    'h2.hometitle',
    '.section__heading',
    '.testimonial-item',
  ];

  var revealObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('md-visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll(revealTargets.join(',')).forEach(function (el, i) {
    el.classList.add('md-reveal');
    if (i % 4 === 1) el.classList.add('md-reveal-delay-1');
    if (i % 4 === 2) el.classList.add('md-reveal-delay-2');
    if (i % 4 === 3) el.classList.add('md-reveal-delay-3');
    revealObserver.observe(el);
  });

  /* ── Back to top button ── */
  var backTop = document.createElement('a');
  backTop.id = 'md-back-top';
  backTop.href = '#';
  backTop.setAttribute('aria-label', 'Retour en haut');
  backTop.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="18 15 12 9 6 15"/></svg>';
  document.body.appendChild(backTop);

  window.addEventListener('scroll', function () {
    backTop.classList.toggle('md-visible', window.scrollY > 400);
  }, { passive: true });

  backTop.addEventListener('click', function (e) {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  /* ── Toast helper ── */
  var toastEl = document.createElement('div');
  toastEl.id = 'md-toast';
  document.body.appendChild(toastEl);
  var toastTimer;

  window.mdToast = function (msg, duration) {
    clearTimeout(toastTimer);
    toastEl.textContent = msg;
    toastEl.classList.add('md-show');
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('md-show');
    }, duration || 3000);
  };

  /* ── Cart count bounce on update ── */
  var cartCount = document.querySelector('.cart-count-bubble, .cart-count, .header-cart-count');
  if (cartCount) {
    var origAddToCart = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var result = origAddToCart.apply(this, args);
      if (typeof args[0] === 'string' && args[0].includes('/cart/add')) {
        result.then(function () {
          var bubble = document.querySelector('.cart-count-bubble, .cart-count, .header-cart-count');
          if (bubble) {
            bubble.classList.remove('md-cart-bounce');
            void bubble.offsetWidth;
            bubble.classList.add('md-cart-bounce');
          }
        });
      }
      return result;
    };
  }

  /* ── Sticky Add-to-Cart (mobile product page) ── */
  var atcBtn = document.querySelector('.product-form__submit, button[name="add"]');
  var priceEl = document.querySelector('.product__price .price-item--sale, .product__price .price-item--regular');

  if (atcBtn && window.innerWidth <= 767) {
    var stickyBar = document.createElement('div');
    stickyBar.id = 'md-sticky-atc';

    var priceSpan = document.createElement('span');
    priceSpan.className = 'md-sticky-price';
    priceSpan.textContent = priceEl ? priceEl.textContent.trim() : '';

    var stickyBtn = document.createElement('button');
    stickyBtn.className = 'md-sticky-btn';
    stickyBtn.textContent = atcBtn.textContent.trim() || 'Ajouter au panier';
    stickyBtn.addEventListener('click', function () {
      atcBtn.click();
    });

    stickyBar.appendChild(priceSpan);
    stickyBar.appendChild(stickyBtn);
    document.body.appendChild(stickyBar);

    var atcObserver = new IntersectionObserver(function (entries) {
      stickyBar.classList.toggle('md-atc-visible', !entries[0].isIntersecting);
    }, { threshold: 0 });
    atcObserver.observe(atcBtn);
  }

  /* ── Quantity input — wheel scroll ── */
  document.querySelectorAll('input[name="quantity"], input.quantity__input').forEach(function (input) {
    input.addEventListener('wheel', function (e) {
      e.preventDefault();
      var val = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, val + (e.deltaY < 0 ? 1 : -1));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }, { passive: false });
  });


  /* ── Product image keyboard navigation ── */
  document.querySelectorAll('.thumbnail-list__item').forEach(function (thumb, i) {
    thumb.setAttribute('tabindex', '0');
    thumb.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        thumb.click();
      }
    });
  });

  /* ── Auto-dismiss success messages ── */
  document.querySelectorAll('.form-message--success, .notice.success').forEach(function (msg) {
    setTimeout(function () {
      msg.style.transition = 'opacity .5s';
      msg.style.opacity = '0';
      setTimeout(function () { msg.remove(); }, 500);
    }, 5000);
  });

  /* ── Smooth anchor links ── */
  document.querySelectorAll('a[href^="#"]:not([href="#"])').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = document.querySelector(a.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ── FAQ accordion keyboard ── */
  document.querySelectorAll('details').forEach(function (details) {
    details.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && details.open) {
        details.open = false;
        details.querySelector('summary').focus();
      }
    });
  });

  /* ── Copy to clipboard on code blocks (discount code) ── */
  document.querySelectorAll('[data-copy]').forEach(function (el) {
    el.style.cursor = 'pointer';
    el.title = 'Copier le code';
    el.addEventListener('click', function () {
      navigator.clipboard.writeText(el.dataset.copy || el.textContent.trim())
        .then(function () { window.mdToast('Code copié ! ✓'); });
    });
  });

  /* ── Enhance number inputs with +/- if not already done ── */
  document.querySelectorAll('.quantity__input').forEach(function (input) {
    var wrapper = input.closest('.quantity');
    if (!wrapper) return;
    var minus = wrapper.querySelector('.quantity__button[name="minus"]');
    var plus  = wrapper.querySelector('.quantity__button[name="plus"]');
    if (!minus || !plus) return;

    [minus, plus].forEach(function (btn) {
      btn.style.fontSize = '18px';
      btn.style.fontWeight = '600';
      btn.style.transition = 'background .15s, color .15s';
      btn.addEventListener('mouseenter', function () {
        btn.style.background = 'rgba(127,0,255,.08)';
        btn.style.color = '#7f00ff';
      });
      btn.addEventListener('mouseleave', function () {
        btn.style.background = '';
        btn.style.color = '';
      });
    });
  });

})();
